const prefix = "PRISMS_USER_";

export const EDIT_GET_FAILED = prefix + "EDIT_GET_FAILED";
export const EDIT_GET_STARTED = prefix + "EDIT_GET_STARTED";
export const EDIT_GET_SUCCEEDED = prefix + "EDIT_GET_SUCCEEDED";
export const EDIT_SAVE_FAILED = prefix + "EDIT_SAVE_FAILED";
export const EDIT_SAVE_STARTED = prefix + "EDIT_SAVE_STARTED";
export const EDIT_SAVE_SUCCEEDED = prefix + "EDIT_SAVE_SUCCEEDED";

export const DISABLE_MFA_STARTED = prefix + "DISABLE_MFA_STARTED";
export const DISABLE_MFA_SUCCEEDED = prefix + "DISABLE_MFA_SUCCEEDED";
export const DISABLE_MFA_FAILED = prefix + "DISABLE_MFA_FAILED";
export const ENABLE_MFA_STARTED = prefix + "ENABLE_MFA_STARTED";
export const ENABLE_MFA_SUCCEEDED = prefix + "ENABLE_MFA_SUCCEEDED";
export const ENABLE_MFA_FAILED = prefix + "ENABLE_MFA_FAILED";
export const SWITCH_TO_EMAIL_MFA_STARTED = prefix + "SWITCH_TO_EMAIL_MFA_STARTED";
export const SWITCH_TO_EMAIL_MFA_SUCCEEDED = prefix + "SWITCH_TO_EMAIL_MFA_SUCCEEDED";
export const SWITCH_TO_EMAIL_MFA_FAILED = prefix + "SWITCH_TO_EMAIL_MFA_FAILED";

export const EDIT_SET_DATA = prefix + "EDIT_SET_DATA";
export const EXPORT_FAILED = prefix + "EXPORT_FAILED";
export const EXPORT_STARTED = prefix + "EXPORT_STARTED";
export const EXPORT_SUCCEEDED = prefix + "EXPORT_SUCCEEDED";
export const LIST_CLEAR_CRITERIA = prefix + "LIST_CLEAR_CRITERIA";
export const LIST_FAILED = prefix + "LIST_FAILED";
export const LIST_SET_CRITERIA = prefix + "LIST_SET_CRITERIA";
export const LIST_SET_CRITERIA_DESCRIPTION = prefix + "LIST_SET_CRITERIA_DESCRIPTION";
export const LIST_SET_PAGING = prefix + "LIST_SET_PAGING";
export const LIST_STARTED = prefix + "LIST_STARTED";
export const LIST_SUCCEEDED = prefix + "LIST_SUCCEEDED";
export const STATE_HIDE_ERROR = prefix + "STATE_HIDE_ERROR";
export const STATE_RESET = prefix + "STATE_RESET";
export const STATE_UNLOAD = prefix + "STATE_UNLOAD";
export const VIEW_CLEAR = prefix + "VIEW_CLEAR";
export const VIEW_FAILED = prefix + "VIEW_FAILED";
export const VIEW_NEXT = prefix + "VIEW_NEXT";
export const VIEW_PREVIOUS = prefix + "VIEW_PREVIOUS";
export const VIEW_STARTED = prefix + "VIEW_STARTED";
export const VIEW_SUCCEEDED = prefix + "VIEW_SUCCEEDED";
export const VIEW_MFA_PROFILE_STARTED = prefix + "VIEW_MFA_PROFILE_STARTED";
export const VIEW_MFA_PROFILE_SUCCEEDED = prefix + "VIEW_MFA_PROFILE_SUCCEEDED";
export const VIEW_MFA_PROFILE_FAILED = prefix + "VIEW_MFA_PROFILE_FAILED";

export const SETUP_AUTHENTICATOR_APP_MFA_STARTED = prefix + "SETUP_AUTHENTICATOR_APP_MFA_STARTED";
export const SETUP_AUTHENTICATOR_APP_MFA_SUCCEEDED = prefix + "SETUP_AUTHENTICATOR_APP_MFA_SUCCEEDED";
export const SETUP_AUTHENTICATOR_APP_MFA_FAILED = prefix + "SETUP_AUTHENTICATOR_APP_MFA_FAILED";

export const SETUP_AUTHENTICATOR_APP_MFA_GET_STARTED = prefix + "SETUP_AUTHENTICATOR_APP_MFA_GET_STARTED";
export const SETUP_AUTHENTICATOR_APP_MFA_GET_SUCCEEDED = prefix + "SETUP_AUTHENTICATOR_APP_MFA_GET_SUCCEEDED"
export const SETUP_AUTHENTICATOR_APP_MFA_GET_FAILED = prefix + "SETUP_AUTHENTICATOR_APP_MFA_GET_FAILED";


